import { render, staticRenderFns } from "./ServicoContr.vue?vue&type=template&id=50ad95ce&scoped=true&"
import script from "./ServicoContr.vue?vue&type=script&lang=js&"
export * from "./ServicoContr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ad95ce",
  null
  
)

export default component.exports